import { updateWidthOfCdnImage } from '@admin-panel/utils';
import { Image as AntdImage, ImageProps as AntdImageProps } from 'antd';

interface IProps extends AntdImageProps {
  resizeWidth?: number;
}

export const Image = ({ resizeWidth, ...props }: IProps) => {
  return (
    <AntdImage
      {...props}
      src={resizeWidth ? updateWidthOfCdnImage(props.src, resizeWidth) : props.src}
    />
  );
};
